import { render, staticRenderFns } from "./pd-reviews.vue?vue&type=template&id=ba0724aa&"
import script from "./pd-reviews.vue?vue&type=script&lang=js&"
export * from "./pd-reviews.vue?vue&type=script&lang=js&"
import style0 from "./pd-reviews.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductName: require('/opt/build/repo/storefront/components/legacy/global/product-name.vue').default,BaseHeading: require('/opt/build/repo/storefront/components/atoms/Text/BaseHeading.vue').default,ReviewStars: require('/opt/build/repo/storefront/components/molecules/Review/ReviewStars.vue').default,ReviewCard: require('/opt/build/repo/storefront/components/molecules/Review/ReviewCard.vue').default,PageNumbers: require('/opt/build/repo/storefront/components/legacy/global/page-numbers.vue').default})
